/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'share-modal.access-level-disclaimer':
    '{entity, select, project {Jeder mit Zugriff auf den Arbeitsbereich kann dieses Projekt sehen.} goal {Jeder mit Zugriff auf den Arbeitsbereich kann dieses Ziel sehen.} other {Jeder mit Zugriff auf den Arbeitsbereich kann Folgendes sehen:}}',
  'share-modal.accordion-button-label':
    '{entity, select, project {Wer erhält wöchentliche Projekt-Updates?} goal {Wer erhält wöchentliche Updates zu Zielen?} other {Wer erhält wöchentliche Updates?}}',
  'share-modal.add-as-follower-checkbox-label': 'Als Follower hinzufügen',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Follower erhalten in ihrer Zusammenfassung ein wöchentliches Update zum Projekt} goal {Follower erhalten in ihrer Zusammenfassung ein wöchentliches Update zum Ziel} other {Follower erhalten in ihrer Zusammenfassung ein wöchentliches Update zu Folgendem:}}',
  'share-modal.all-tab-label': 'Alle',
  'share-modal.contributors-tab-label': 'Beitragende',
  'share-modal.copy-link-button': 'Link kopieren',
  'share-modal.copy-link-button.copied-tooltip': 'Kopiert!',
  'share-modal.copy-link-button.tooltip':
    '{entity, select, project {Link zum Projekt kopieren} goal {Link zum Ziel kopieren} other {Link zu Folgendem kopieren: }}',
  'share-modal.followers-tab-label': 'Follower',
  'share-modal.followers-title': 'Follower',
  'share-modal.modal.user-picker.add-more-placeholder': 'Weitere Personen hinzufügen',
  'share-modal.share-button': 'Teilen',
  'share-modal.share-title': 'Teilen',
  'share-modal.user-item.can-edit-label': 'Kann bearbeiten',
  'share-modal.user-picker.placeholder': 'Personen suchen und einladen',
  'shareModal.followers-empty-state.default-title': 'Es fehlen wichtige Stakeholder?',
  'shareModal.followers-empty-state.goal-cta':
    'Stellen Sie sicher, dass sie die neuesten Updates zu Ihrem Ziel in ihrer monatlichen Zusammenfassung erhalten, indem Sie sie als Follower hinzufügen oder einen Slack-Channel oder MS Teams-Kanal verbinden.',
  'shareModal.followers-empty-state.project-cta':
    'Fügen Sie wichtige Teams und Stakeholder als Follower hinzu, um diese auf dem Laufenden zu halten. Verbinden Sie einen Kanal, um Updates direkt im Chat zu teilen.',
  'shareModal.followers-empty-state.project-title': 'Durch Hinzufügen von Followern ein breiteres Publikum erreichen',
};
